import { NgModule } from "@angular/core";
import { ButtonModule } from "./buttons/buttons.module";
import { NgxMaskModule } from "ngx-mask";

@NgModule({
    imports: [
        ButtonModule,
        NgxMaskModule.forRoot(),
    ],
    exports: [
        ButtonModule
    ]
})
export class ComponentsModule { }
